export default "assets/images/flags/be-33daca9a.svg";